import { useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useWorkerGeoLocation } from "../../Worker/useWorkerGeoLocation";
import { WorkerGeolocationMissingBottomSheet } from "./WorkerGeolocationMissingBottomSheet";

export function WorkerGeolocationMissingBottomSheetContainer() {
  const modalState = useModalState();
  const workerGeoLocation = useWorkerGeoLocation();
  const history = useHistory();

  const { setModalStatus } = modalState;

  const isMissing = !isDefined(workerGeoLocation);

  useEffect(() => {
    if (isMissing) {
      setModalStatus("open");
    }
  }, [isMissing, setModalStatus]);

  useLogEffect(
    APP_V2_USER_EVENTS.GEOLOCATION_MISSING_ALERT_VIEWED,
    {},
    {
      enabled: isMissing,
    }
  );

  return (
    <WorkerGeolocationMissingBottomSheet
      modalState={modalState}
      onCancel={() => {
        logEvent(APP_V2_USER_EVENTS.GEOLOCATION_MISSING_ALERT_CANCELLED);
        modalState.closeModal();
      }}
      onClickUpdate={() => {
        logEvent(APP_V2_USER_EVENTS.GEOLOCATION_MISSING_ALERT_UPDATE_ADDRESS_BUTTON_CLICKED);
        modalState.closeModal();
        history.push(DeprecatedGlobalAppV1Paths.ADDRESS);
      }}
    />
  );
}
